<template>
  <div class="contact-us">
    <div class="section content">
      <div class="">
        <div class="container">
          <div class="row centered">
            <div class="col-md-8 col-md-offset-2 text-center">
              <!-- <img src="@/assets/img/404.png" alt /> -->
              <h2 class="title">
                {{ $t("pages.notFound.error") }}
              </h2>
              <h3 class="title">
                {{ $t("pages.notFound.scan_qr_code") }}
              </h3>             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
.centered {
  justify-content: center;
}
img{
  width:500px;
  padding-top: 40px;
  padding-bottom: 40px;
  margin: auto;
  display: block
}
h2{
  padding-top: 80px;
  font-family: "Montserrat";
  padding-bottom: 50px;
}
h3{
  font-family: "Montserrat";
  padding-bottom: 50px;
}
</style>
